import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../servicios/api';

import tipoEstadocivil from '../../data/estadocivil.json';
import tipoEducacion from '../../data/tipoeducacion.json';
import tipoJornada from '../../data/jornadaescolar.json';
// import tipoCategoriaseguimiento  from '../../data/categorias_seguimiento.json';
import tipoProgramas from '../../data/tipoprogramas.json';
import tipoOcupaciones from '../../data/ocupaciones.json';

class Perfil2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            tipoOcupaciones2: tipoOcupaciones.tipo,
            datosCargados:false,
            empleado: [],
            errores: [],
            serverror: ""
         };
    }

    componentDidMount(){
        const keyAPI = this.props.match.params.claveapi; // Se cambio para evitar usuarios curiosos
        fetch(API +"?consultarKeyAPI", {
            method:"POST",
            body: JSON.stringify({claveAPI:keyAPI})
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.length>0 && datos[0].claveAPI){
                // Format some values
                let empleado = datos[0];
                if(empleado.estadocivil==="") empleado.estadocivil="Seleccionar...";
                if(empleado.jefehogar==="") empleado.jefehogar="Seleccionar...";
                if(empleado.educacion==="") empleado.educacion="Seleccionar...";
                if(empleado.jornada==="") empleado.jornada="Seleccionar...";
                if(empleado.otraocupacion==="") empleado.otraocupacion="Seleccionar...";
                if(empleado.programaprincipal==="") empleado.programaprincipal="Seleccionar...";
                empleado.estudiaactualmente = (empleado.estudiaactualmente === "1") ? "Si" : "No";
                empleado.acuerdocorresp = (empleado.acuerdocorresp === "1") ? "Si" : "No";
                // Corregir fechas
                // empleado.fechaingreso = empleado.fechaingreso.split(" ")[0];
                this.setState({ 
                    datosCargados:true,
                    empleado: empleado
                });
            } else {
                this.setState({ 
                    datosCargados:true,
                    empleado: []
                });
            }
        })
        .catch(console.log)
    }

    cambioValor = (e) =>{
        const state = this.state.empleado;
        state[e.target.name] = e.target.value;
        this.setState( { empleado:state, errores:[], serverror:""});
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        let { id, docId, claveAPI,
            estadocivil, educacion, nivelescolaridad, 
            estudiaactualmente, carrera, institucion, jornada, 
            jefehogar, personasacargo, numhijos, otraocupacion, 
            programaprincipal, acuerdocorresp,
            // categoriaseguimiento
        } = this.state.empleado;

        // Validar Errores
        let errores = [];
        if (!docId) errores.push('error_docId');
        if (!estadocivil) errores.push('error_estadocivil');
        if (!educacion) errores.push('error_educacion');
        if (!nivelescolaridad) errores.push('error_nivelescolaridad');
        if (!estudiaactualmente) errores.push('error_estudiaactualmente');
        // if (!carrera) errores.push('error_carrera');
        // if (!institucion) errores.push('error_institucion');
        if (!jornada) errores.push('error_jornada');
        if (!otraocupacion) errores.push('error_otraocupacion');
        if (!jefehogar) errores.push('error_jefehogar');
        if (!personasacargo) errores.push('error_personasacargo');
        if (!numhijos) errores.push('error_numhijos');

        if (!acuerdocorresp) errores.push('error_acuerdocorresp');
        
        if(estadocivil==="Seleccionar...") errores.push('error_estadocivil');
        if(jefehogar==="Seleccionar...") errores.push('error_jefehogar');
        if(jornada==="Seleccionar...") errores.push('error_jornada');
        if(educacion==="Seleccionar...") errores.push('error_educacion');
        if(otraocupacion==="Seleccionar...") otraocupacion="No Aplica"; //errores.push('error_otraocupacion');
        if(programaprincipal==="Seleccionar...") errores.push('error_programaprincipal');
        // if(categoriaseguimiento==="Seleccionar...") errores.push('error_categoriaseguimiento');

        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }

        if (estudiaactualmente.toLocaleLowerCase()==="si" || estudiaactualmente.toLocaleLowerCase()==="1"){
            estudiaactualmente = 1;
        } else {
            estudiaactualmente = 0;
        }
        if (acuerdocorresp.toLocaleLowerCase()==="si" || acuerdocorresp.toLocaleLowerCase()==="1"){
            acuerdocorresp = 1;
        } else {
            acuerdocorresp = 0;
        }

        // Validar los campos con numeros (nivelescolaridad,personasacargo, numhijos)


        var datosaEnviar = { id:id, claveAPI:claveAPI,
            docId:docId, 
            estadocivil:estadocivil, educacion:educacion, nivelescolaridad:nivelescolaridad, 
            estudiaactualmente:estudiaactualmente, carrera:carrera, institucion:institucion, 
            jornada:jornada, jefehogar:jefehogar,
            personasacargo:personasacargo, numhijos:numhijos, otraocupacion:otraocupacion, 
            programaprincipal:programaprincipal, 
            // categoriaseguimiento:categoriaseguimiento, 
            acuerdocorresp:acuerdocorresp,
        };
        // console.log(datosaEnviar);
        fetch(API +"?actualizarperfil2=1", {
            method:"POST",
            body: JSON.stringify(datosaEnviar)
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                this.setState({serverror:datos.error});
            } else {
                this.props.history.push("/perfil3/"+datos.claveAPI);
            }
        })
        .catch(console.log)
    }

    // Filter Ocupación
    // _filterFunction = (e) => {
    //     var input, filter, div, a, i; //ul, li,
    //     input = document.getElementById("myInput");
    //     if (input){
    //         filter = input.value.toUpperCase();
    //         div = document.getElementById("myDropdown");
    //         // a = div.getElementsByTagName("a");
    //         a = div.getElementsByTagName("button"); //options
    //         // <li><button onClick={this.cambioValor} key={e.id} name="otraocupacion" value={e.name} className="dropdown-item" type="button">{e.name}</button>
    //         for (i = 0; i < a.length; i++) {
    //             let txtValue = a[i].textContent || a[i].innerText;
    //             if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                 a[i].style.display = "";
    //             } else {
    //                 a[i].style.display = "none";
    //             }
    //         }
    //     }
        
    // };

    filterFunction = (e) =>{
        let filter = e.target.value.toUpperCase();
        let tipoOcupaciones2 = tipoOcupaciones.tipo.filter(o => {
            return o.name.toUpperCase().indexOf(filter) !== -1
        });
        this.setState({tipoOcupaciones2: tipoOcupaciones2});
    }


    render() { 

        const { 
            tipoOcupaciones2, datosCargados, empleado, serverror
        } = this.state;
        const { 
            // id,
            docId, claveAPI,
            estadocivil, educacion, nivelescolaridad, 
            estudiaactualmente, carrera, institucion, jornada, 
            jefehogar, personasacargo, numhijos, otraocupacion, 
            programaprincipal,  acuerdocorresp //categoriaseguimiento,
        } = empleado;

        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos...</div>);
        } else {
            if (datosCargados && empleado.length===0){
                return (<div>No hay registros</div>);
            } else {
        return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>PERFIL EMPLEADO</strong></div>
                        <div>2 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Número Documento</strong></label>
                            <input readOnly type="text" name="docId" value={docId} onChange={this.cambioValor} id="docId"
                                className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Estado Civil</strong></label>
                                <div className={((this.verificarError("error_estadocivil")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {estadocivil}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoEstadocivil.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="estadocivil" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Jefe Hogar</strong></label>
                                <div className={((this.verificarError("error_jefehogar")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {jefehogar}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="jefehogar" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="jefehogar" value="No" className="dropdown-item" type="button">No</button>
                                        <button onClick={this.cambioValor} key={3} name="jefehogar" value="Compartido" className="dropdown-item" type="button">Compartido</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Personas a Cargo</strong></label>
                                <input type="number" id="personasacargo" name="personasacargo" value={personasacargo} onChange={this.cambioValor}
                                    className={((this.verificarError("error_personasacargo")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Número de hijos</strong></label>
                                <input type="number" id="numhijos" name="numhijos" value={numhijos} onChange={this.cambioValor}
                                    className={((this.verificarError("error_numhijos")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Nivel Educativo</strong></label>
                                <div className={((this.verificarError("error_educacion")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {educacion}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {tipoEducacion.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="educacion" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Nivel de Escolaridad</strong></label>
                                <input type="number" id="nivelescolaridad" name="nivelescolaridad" value={nivelescolaridad} onChange={this.cambioValor}
                                    className={((this.verificarError("error_nivelescolaridad")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Dígite el número del último grado o semestre que cursó y aprobó.</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group">
                                <label htmlFor=""><strong>Estudia Actualmente?</strong></label>
                                <div className="dropdown">
                                    <button className="btn btn-info dropdown-size"
                                        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {estudiaactualmente}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="estudiaactualmente" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="estudiaactualmente" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Jornada</strong></label>
                                <div className={((this.verificarError("error_jornada")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {jornada}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoJornada.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="jornada" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Carrera</strong></label>
                                <input type="text" id="carrera" name="carrera" value={carrera} onChange={this.cambioValor}
                                    className={((this.verificarError("error_carrera")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Institución</strong></label>
                                <input type="text" id="institucion" name="institucion" value={institucion} onChange={this.cambioValor}
                                    className={((this.verificarError("error_institucion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Otra ocupación</strong></label>
                            {/* <div className={((this.verificarError("error_otraocupacion")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {otraocupacion}
                                </button>
                                <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                    {tipoOcupaciones.tipo.map(e => {
                                        return (
                                            <button onClick={this.cambioValor} key={e.id} name="otraocupacion" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                        )
                                    })}
                                </div>
                            </div> */}
                            <div className={((this.verificarError("error_otraocupacion")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" data-toggle="dropdown">{otraocupacion}
                                    <span className="caret"></span></button>
                                <ul className="dropdown-menu dropdown-menu-longlist">
                                    <input className="form-control" id="myInput" type="text" placeholder="Buscar..." onKeyUp={this.filterFunction} />
                                    {tipoOcupaciones2.map(e => {
                                        return (
                                            <li key={e.id}><button onClick={this.cambioValor} key={e.id} name="otraocupacion" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Programa en el cual desearía participar?</strong></label>
                            <div className={((this.verificarError("error_programaprincipal")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {programaprincipal}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    {tipoProgramas.tipo.map(e => {
                                        return (
                                            <button onClick={this.cambioValor} key={e.id} name="programaprincipal" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                        )
                                    })}
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Acuerdo de corresponsabilidad firmado?</strong></label>
                            <div className="dropdown">
                                <button className="btn btn-info dropdown-size-2"
                                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {acuerdocorresp}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="acuerdocorresp" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="acuerdocorresp" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                        </div>

                        <div className="server-error">{serverror}</div>

                        <hr width="90%"/>
                        <div className="btn-group btn-acciones" aria-label="">
                            <div className='btn-size-sm'><Link to={"/perfileditar/"+claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                            <div><button type="submit" className="btn btn-success">Siguiente</button></div>
                        </div>
                        
                    </form>
                </div>
                {/* <div className="card-footer text-muted">
                    
                </div> */}
            </div>
        );
            }
        }
    }
}

export default Perfil2;